/**
 * 登录相关路由配置
 */
const loginRoutes = [
  {
    path: '/splash',
    name: 'Splash',
    component: () => import('@/views/login/SplashView.vue'),
    meta: {
      title: '欢迎',
      noAuth: true,
      hideNav: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/LoginView.vue'),
    meta: {
      title: '登录',
      noAuth: true,
      hideNav: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/login/RegisterView.vue'),
    meta: {
      title: '注册',
      noAuth: true,
      hideNav: true
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/login/ResetPasswordView.vue'),
    meta: {
      title: '修改密码',
      noAuth: true,
      hideNav: true
    }
  },
  {
    path: '/invite-rule',
    name: 'InviteRule',
    component: () => import('@/views/login/InviteRuleView.vue'),
    meta: {
      title: '邀请码规则',
      noAuth: true,
      hideNav: true
    }
  }
]

export default loginRoutes
